import { useTranslation } from "react-i18next";
import { useMatches } from "@tanstack/react-router";

export const useBreadcrumbLookup = () => {
  const { t } = useTranslation();
  const matches = useMatches();

  return (url: string) => {
    // A layout and its index route share a pathname, so the deepest match owns the label.
    const match = matches.findLast((m) => m.pathname === url || m.pathname === `${url}/`);
    const breadcrumbKey = match?.staticData?.breadcrumb;
    if (breadcrumbKey) {
      return t(breadcrumbKey);
    }
    return undefined;
  };
};
